import { html, Html, View } from 'rune-ts';
import {
  EditCreatorProductData,
  EditCreatorProductData_TPL,
  EditCreatorProductData_TPL_INTL,
  NewCreatorProductData,
} from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';
import klass from './CreatorProductEditorModal.module.scss';
import { Modal } from '@services/MarppleShop/renderApp/components/atoms/Modal/Modal.ts';
import {
  EditCreatorProductEditor,
  EditTplCreatorProductEditor,
  EditTplIntlCreatorProductEditor,
  NewCreatorProductEditor,
} from '@services/MarppleShopStudio/widget/CreatorProduct/ui/CreatorProductEditor.ts';

export class CreatorProductEditorModal extends View {
  private modal = new Modal({
    isOpen: false,
    size: 'free',
    body: html``,
    full_width: true,
    modal_klass: `${klass.root}`,
    full_body_height: true,
    disable_escape_keydown: true,
    backdrop_not_close: true,
    title_options: {
      title_align: 'center',
    },
  });

  protected override template(): Html {
    return html`<div>${this.modal}</div>`;
  }

  public openNew(data: NewCreatorProductData) {
    this.modal
      .setTitle(T('question::상품 등록하기'))
      .setBody(new NewCreatorProductEditor(data))
      .redraw()
      .open();
  }

  public openEdit(data: EditCreatorProductData) {
    this.modal
      .setTitle(T('question::상품 수정하기'))
      .setBody(new EditCreatorProductEditor(data))
      .redraw()
      .open();
  }

  public openEdit_TPL(data: EditCreatorProductData_TPL) {
    this.modal
      .setTitle(T('question::상품 수정하기'))
      .setBody(new EditTplCreatorProductEditor(data))
      .redraw()
      .open();
  }

  public openEdit_TPL_INTL(data: EditCreatorProductData_TPL_INTL) {
    this.modal
      .setTitle(T('question::상품 수정하기'))
      .setBody(new EditTplIntlCreatorProductEditor(data))
      .redraw()
      .open();
  }
}
